import { useGetLuckyCardState } from '../../../../api/gpt/luckyCard/luckyCard.hooks';
import { HTTP_NO_CONTENT } from '../constants';
import { useGPTGameTrigger } from './useGPTGameTrigger';

export const useCheckForLuckyCard = () => {
  const { mutateAsync: getLuckyCardState } = useGetLuckyCardState({});
  const { triggerGPTGame } = useGPTGameTrigger();

  return ({ withdrawAmount, gameId }: { withdrawAmount?: number; gameId?: number }) => {
    getLuckyCardState({ cashOutAmount: withdrawAmount, gameId }).then((response) => {
      if (response.status === HTTP_NO_CONTENT) {
        triggerGPTGame('cardGame');
      }
    });
  };
};
